import axios from "axios";
import { useState } from "react";
import { FaArrowLeft, FaPlus, FaSave, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AddJurnalKepsek = () => {
  const navigate = useNavigate();

  const [tanggal, setTanggal] = useState("");
  const [jurnal, setJurnal] = useState([
    { judul: "", tujuan: "", kegiatan: "", keterangan: "" },
  ]);
  const [loading, setLoading] = useState(false);

  const handleChange = (index, field, value) => {
    const updated = [...jurnal];
    updated[index][field] = value;
    setJurnal(updated);
  };

  const addRow = () => {
    setJurnal([
      ...jurnal,
      { judul: "", tujuan: "", kegiatan: "", keterangan: "" },
    ]);
  };

  const removeRow = (index) => {
    if (jurnal.length === 1) return;
    setJurnal(jurnal.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tanggal) return alert("Tanggal wajib diisi");

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${process.env.REACT_APP_API_URL}api/jurnal-kepsek`,
        { tanggal, jurnal },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert("Jurnal Kepala Sekolah berhasil disimpan");

      // Reset form
      setTanggal("");
      setJurnal([{ judul: "", tujuan: "", kegiatan: "", keterangan: "" }]);
    } catch (err) {
      if (err.response?.status === 409) {
        alert("❌ Jurnal dengan tanggal ini sudah ada");
      } else {
        alert("❌ Gagal menyimpan jurnal");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-3 sm:p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow p-4 sm:p-6">
        {/* HEADER */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
          <div>
            <h1 className="text-lg sm:text-xl font-semibold">
              Tambah Jurnal Kepala Sekolah
            </h1>
            <p className="text-sm text-gray-500">
              Catatan kegiatan kepala sekolah per tanggal
            </p>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-3 py-2 border rounded-lg hover:bg-gray-50"
          >
            <FaArrowLeft size={14} /> Kembali
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* TANGGAL */}
          <div className="mb-6">
            <label className="block text-sm font-medium mb-1">Tanggal</label>
            <input
              type="date"
              className="w-full sm:w-64 border rounded-lg px-3 py-2"
              value={tanggal}
              onChange={(e) => setTanggal(e.target.value)}
              required
            />
          </div>

          {/* TABLE (TABLET & PC) */}
          <div className="hidden md:block">
            <div className="overflow-x-auto border rounded-lg">
              <table className="w-full border-collapse">
                <thead className="bg-gray-200 text-sm">
                  <tr>
                    <th className="border px-3 py-2 w-12">No</th>
                    <th className="border px-3 py-2">Judul</th>
                    <th className="border px-3 py-2">Tujuan</th>
                    <th className="border px-3 py-2">Kegiatan</th>
                    <th className="border px-3 py-2">Keterangan</th>
                    <th className="border px-3 py-2 w-20">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {jurnal.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="border text-center">{index + 1}</td>

                      {["judul", "tujuan", "kegiatan", "keterangan"].map(
                        (field) => (
                          <td key={field} className="border px-2 py-1">
                            <textarea
                              rows={field === "judul" ? 1 : 2}
                              className="w-full border rounded-md px-2 py-1 text-sm"
                              maxLength={
                                field === "judul"
                                  ? 100
                                  : field === "tujuan"
                                  ? 200
                                  : field === "kegiatan"
                                  ? 200
                                  : field === "keterangan"
                                  ? 200
                                  : 100
                              }
                              value={item[field]}
                              onChange={(e) =>
                                handleChange(index, field, e.target.value)
                              }
                              required={field === "judul"}
                            />
                          </td>
                        )
                      )}

                      <td className="border text-center">
                        <button
                          type="button"
                          onClick={() => removeRow(index)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* MOBILE CARD */}
          <div className="md:hidden space-y-4">
            {jurnal.map((item, index) => (
              <div
                key={index}
                className="bg-gray-50 border rounded-xl p-4 shadow-sm"
              >
                <div className="flex justify-between items-center mb-3">
                  <h3 className="font-medium text-sm">Jurnal #{index + 1}</h3>
                  <button
                    type="button"
                    onClick={() => removeRow(index)}
                    className="text-red-600"
                  >
                    <FaTrash />
                  </button>
                </div>

                {["judul", "tujuan", "kegiatan", "keterangan"].map((field) => (
                  <div key={field} className="mb-3">
                    <label className="block text-xs font-medium capitalize mb-1">
                      {field}
                    </label>
                    <textarea
                      rows={field === "judul" ? 1 : 2}
                      className="w-full border rounded-lg px-3 py-2 text-sm"
                      value={item[field]}
                      onChange={(e) =>
                        handleChange(index, field, e.target.value)
                      }
                      required={field === "judul"}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* ACTION */}
          <div className="flex flex-col sm:flex-row gap-3 mt-6">
            <button
              type="button"
              onClick={addRow}
              className="flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
            >
              <FaPlus /> Tambah Baris
            </button>

            <button
              type="submit"
              disabled={loading}
              className="flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700"
            >
              <FaSave />
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddJurnalKepsek;
